<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <img src="@/assets/images/logo/reavn_logo.png" width="250" alt="login" class="mx-auto mt-10">
              <div class="vx-row no-gutter justify-center items-center">
              <div class="px-8 vx-card__title mb-4">
              <h4 class="mb-4 justify-center items-center align-center">Real Estate <span class="lg:inline hidden">Appriasal &amp;</span> Valuation Network</h4>
               </div>
             </div>
              <div class="px-8 login-tabs-container justify-center items-center">
                <form name="form" @submit.prevent="handleLogin">
                <div>
                  <div class="error">
                   <p class="text-danger">{{ this.error }}</p>
                </div>
                <div class="vx-row no-gutter justify-center items-center">
                    <vs-input
                        v-validate="'required|email|min:3'"
                        data-vv-validate-on="blur|change"
                        name="email"
                        autofocus="true"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Email"
                        v-model="user.email"
                        class="login-input"/>
                    
                  </div>
                  <div class="vx-row no-gutter justify-center items-center">
                  <span class="error-container text-danger text-sm">{{ errors.first('email') }}</span>
                  </div>
                  <div class="vx-row no-gutter justify-center items-center">
                    <vs-input
                        data-vv-validate-on="blur|change"
                        v-validate="'required|min:6'"
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Password"
                        v-model="user.password"
                        class="login-input mt-6" />
                    
                  </div>
                  <div class="vx-row no-gutter justify-center items-center">
                  <span class="error-container text-danger text-sm">{{ errors.first('password') }}</span>
                  </div>
                  <div class="vx-row no-gutter justify-center items-center">
                    <vs-button type="flat" @click="handleLogin">Login</vs-button>
                  </div>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>

<script>
import User from '@/models/user'
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'Login',
  data () {
    return {
      user: new User('', ''),
      loading: false,
      message: '',
      error: ''
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.auth.status.loggedIn
    }
  },
  created () {
    if (this.loggedIn) {
      //this.$router.push('/profile')
    }
  },
  methods: {
    handleLogin () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false
          return
        }

        if (this.user.email && this.user.password) {
          this.$store.dispatch('admin/login', this.user).then(
            result => {
              let color_val = 'success'
              let title_val = 'Success'
              let message = result.message
              if (result.code !== 200) {
                color_val = 'danger'
                title_val = 'Error'
                message = 'Invalid credentials. Please try again.'
              }
              this.$vs.notify({
                'time':10000,
                'title': title_val,
                'text': message,
                'color': color_val
              })

              if (result.code === 200) {
                //localStorage.setItem('user', JSON.stringify(result))
                localStorage.setItem('token', JSON.stringify(result.token))
                const dt = new Date()
                localStorage.setItem('token_expiry', JSON.stringify(dt.setTime(dt.getTime() + result.expires_in)))

                axios.post(`${process.env.VUE_APP_API_HOST}admin/dashboard`, {}, authHeader()).then(response => {
                  if (response.data.user) {
                    localStorage.setItem('user', JSON.stringify(response.data.user))
                    localStorage.setItem('user_settings', JSON.stringify(response.data.settings))
                    setTimeout(() => this.$router.push('/admin/dashboard'), 200)
                  }
                })
                  .catch(error => {
                    this.error = error.response.data.message
                    return false
                  })
              }
            },
            error => {
              console.log(error)
              this.loading = false
              this.message =
                error.message ||
                error.message.toString()
            }
          )
        }
      })
    }
  }
}
</script>